import { Link } from "react-router-dom";

import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;

  font-family: ${theme.font.poppins};
  color: ${theme.colors.white};

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.darkBlue};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800};
  }

  @media screen and (max-width: 768px) {
    width: 100%;

    .data-grid {
      display: none !important;
    }
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;

  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const CardWrapper = styled.div`
  margin-top: 10px;
  margin: 15px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 15px;
  justify-content: space-between;
  background-color: ${theme.colors.darkBlue};

  @media screen and (max-width: 360px) {
    margin: 0;
  }

  @media screen and (max-width: 479px) {
    div.d-flex {
      flex-wrap: wrap;
      gap: 0.5rem;
    }
  }
`;

export const IframeStyled = styled.iframe`
  width: 100%;
  height: 59vh;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: ${theme.colors.lightGray5};
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.lightGray};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.lightGray6};
  }
`;

export const ButtonComponentStyled = styled(Link)`
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  align-items: center;
  padding: 15px 45px;
  border-radius: 100px;
  font-size: 0.8rem;
  line-height: 1.6;
  &:hover {
    color: ${theme.colors.white};
    opacity: 0.7;
  }
  svg {
    margin-bottom: 2px;
    margin-right: 5px;
  }
`;

export const ContainerButtonActions = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  button {
    margin-left: 10px;
  }
`;
